import "./floorSelectorExtension.scss";

import { FloorSelectionExtensionOptions } from "./floorSelector/floorSelectionExtensionOptions";
import { FloorSelectorPagerToolbar } from "./floorSelector/floorSelectorPagerToolbar";
import { FloorSelectorSimpleToolbar } from "./floorSelector/floorSelectorSimpleToolbar";
import { FloorSelectorToolbar } from "./floorSelector/floorSelectorToolbar";

export class FloorSelectorExtension extends Autodesk.Viewing.Extension {
	private floorToolBar: Autodesk.Viewing.UI.ToolBar;
	private subToolbar: Autodesk.Viewing.UI.ControlGroup | null;
	private toolbar: FloorSelectorToolbar;

	public constructor(viewer: Autodesk.Viewing.GuiViewer3D, public floorSelectorOptions: FloorSelectionExtensionOptions) {
		super(viewer, floorSelectorOptions);
	}

	public load(): boolean {
		return true;
	}

	public unload(): boolean {
		if (this.subToolbar) {
			this.viewer.toolbar.removeControl(this.subToolbar);

			this.subToolbar = null;
		}

		if (this.floorToolBar?.container) {
			this.viewer.container.removeChild(this.floorToolBar.container);
		}

		return true;
	}

	public onToolbarCreated(_toolbar: Autodesk.Viewing.UI.ToolBar): void {
		const options = this.floorSelectorOptions;

		if (this.floorToolBar == null) {
			this.floorToolBar = new Autodesk.Viewing.UI.ToolBar(`${options.autodeskContainerId}-floor-toolbar`, {
				alignVertically: true,
			});
		}

		if (this.showAllFloorButtons) {
			this.toolbar = new FloorSelectorSimpleToolbar(this.floorSelectorOptions, this.floorToolBar);
		} else {
			this.toolbar = new FloorSelectorPagerToolbar(this.floorSelectorOptions, this.floorToolBar);
		}

		if (this.subToolbar == null) {
			this.toolbar.builtToolbarAsync(options.currentFloorLevel);

			this.viewer.container.appendChild(this.floorToolBar.container);
		}
	}

	private get showAllFloorButtons(): boolean {
		const options = this.floorSelectorOptions;
		return options.maxNumberOfFloorButtons == null || options.maxNumberOfFloorButtons > options.viewerFloors.length;
	}
}
